// TODO
import { initKijModules } from '../modules';
import { initKijSubModules } from '../sub-modules';
import { initFormLabel } from '../global-modules/sign-up';

// -----------------------------------------------------------------------------

const html = document.documentElement;
html.classList.remove('no-js');

// -----------------------------------------------------------------------------

initKijModules();
initKijSubModules();
initFormLabel();
